import { ActionTypes } from '../../constants';
import { polyglot } from '../../assets/locales';

let defaultState = {
  list: [
    {
      id: new Date().getTime(),
      title: '',
      cost: '',
      units: '',
      calculatedAmount: '',
      submitDisabled: false,
      checked: false,
      errors: {
        title: polyglot.t('errors.title.empty'),
        cost: polyglot.t('errors.cost.empty'),
        units: polyglot.t('errors.units.empty'),
        submit: polyglot.t('errors.submit'),
      },
    },
  ],
  currentStep: 1,
  continueClicked: false,
};

export default function (state = defaultState, action) {
  switch (action.type) {
    case ActionTypes.SET_IMPROVEMENT:
      return { ...state, list: action.payload.improvements };
    case ActionTypes.RESET_IMPROVEMENTS:
      return { list: defaultState.list, currentStep: defaultState.currentStep };
    case ActionTypes.UPDATE_STEP:
      return { ...state, currentStep: action.payload.currentStep };
    case ActionTypes.CONTINUE_CLICKED:
      return { ...state, continueClicked: action.payload.continueClicked };
    default:
      return state;
  }
}